import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { toUpper } from "../../../utils/to-upper";
import { size } from "../../../utils/size";
import { Button } from "../../elements/Button";
import { ICON_NAMES } from "../../elements/Icon";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { FlexContainer } from "../../layout/FlexContainer";
import { Gallery } from "../../media/Gallery";
import { Divider } from "../../elements/Divider";
import { withResponsive } from "../../../utils/with-responsive";
import { Hero } from "../../collections/Hero";
import { VIEW_MORE_PICTURES } from "../../../utils/default-strings";
import { BOTTOM_OFFSET } from "./constants";

var Component = function Component(_ref) {
  var activeNavigationItemIndex = _ref.activeNavigationItemIndex,
      backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      className = _ref.className,
      galleryImages = _ref.galleryImages,
      headerLogoHref = _ref.headerLogoHref,
      headerLogoSize = _ref.headerLogoSize,
      headerLogoSizes = _ref.headerLogoSizes,
      headerLogoSrc = _ref.headerLogoSrc,
      headerLogoSrcSet = _ref.headerLogoSrcSet,
      headerLogoText = _ref.headerLogoText,
      headerNavigationItems = _ref.headerNavigationItems,
      headerPrimaryCTA = _ref.headerPrimaryCTA,
      headerLogoSubText = _ref.headerLogoSubText,
      isHeaderBackgroundFilled = _ref.isHeaderBackgroundFilled,
      placeholderBackgroundImageUrl = _ref.placeholderBackgroundImageUrl,
      secondaryButtonText = _ref.secondaryButtonText;
  return React.createElement(Hero, {
    activeNavigationItemIndex: activeNavigationItemIndex,
    backgroundImageHeight: backgroundImageHeight,
    backgroundImageSizes: backgroundImageSizes,
    backgroundImageSrcSet: backgroundImageSrcSet,
    backgroundImageUrl: backgroundImageUrl,
    backgroundImageWidth: backgroundImageWidth,
    bottomOffset: BOTTOM_OFFSET,
    className: className,
    headerLogoHref: headerLogoHref,
    headerLogoSize: headerLogoSize,
    headerLogoSizes: headerLogoSizes,
    headerLogoSrc: headerLogoSrc,
    headerLogoSrcSet: headerLogoSrcSet,
    headerLogoSubText: headerLogoSubText,
    headerLogoText: headerLogoText,
    headerNavigationItems: headerNavigationItems,
    headerPrimaryCTA: headerPrimaryCTA,
    isFixedSearchBarDisplayed: true,
    isHeaderBackgroundFilled: isHeaderBackgroundFilled,
    placeholderBackgroundImageUrl: placeholderBackgroundImageUrl
  }, size(galleryImages) > 1 ? React.createElement(Fragment, null, React.createElement(FlexContainer, {
    alignItems: "flex-end"
  }, React.createElement(HorizontalGutters, null, React.createElement(Gallery, {
    images: galleryImages,
    trigger: React.createElement(Button, {
      icon: ICON_NAMES.PLACEHOLDER,
      isCompact: true,
      isPositionedRight: true,
      isSecondary: true
    }, toUpper(secondaryButtonText))
  }))), React.createElement(Divider, null)) : null);
};

Component.displayName = 'PropertyPageHero';
Component.defaultProps = {
  activeNavigationItemIndex: null,
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  className: '',
  galleryImages: [],
  headerLogoHref: undefined,
  headerLogoSize: undefined,
  headerLogoSizes: undefined,
  headerLogoSrc: null,
  headerLogoSrcSet: undefined,
  headerLogoSubText: undefined,
  headerPrimaryCTA: null,
  isHeaderBackgroundFilled: false,
  placeholderBackgroundImageUrl: null,
  secondaryButtonText: VIEW_MORE_PICTURES
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activeNavigationItemIndex: PropTypes.number,
  backgroundImageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundImageSizes: PropTypes.string,
  backgroundImageSrcSet: PropTypes.string,
  backgroundImageUrl: PropTypes.string.isRequired,
  backgroundImageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  galleryImages: PropTypes.arrayOf(PropTypes.shape({
    descriptionText: PropTypes.string,
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired
  })),
  headerLogoHref: PropTypes.string,
  headerLogoSize: PropTypes.oneOf(['medium', 'large', 'huge']),
  headerLogoSizes: PropTypes.string,
  headerLogoSrc: PropTypes.string,
  headerLogoSrcSet: PropTypes.string,
  headerLogoSubText: PropTypes.string,
  headerLogoText: PropTypes.string.isRequired,
  headerNavigationItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
      text: PropTypes.string.isRequired
    })),
    target: PropTypes.string,
    text: PropTypes.string.isRequired
  })).isRequired,
  headerPrimaryCTA: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  }),
  isHeaderBackgroundFilled: PropTypes.bool,
  placeholderBackgroundImageUrl: PropTypes.string,
  secondaryButtonText: PropTypes.string
} : {};
export var ComponentWithResponsive = withResponsive(Component);